var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-account-exchange-page"},[_c(_vm.currentComp,{key:_vm.currentComp,tag:"component",attrs:{"product-id":_vm.productId},on:{"to-detail":_vm.handleToDetail,"to-list":function($event){return _vm.handleCurrentChange(_vm.EnumMyAccountExchange.List)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }